import { Ruler } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { SIZE_GUIDES } from "@/lib/site";
import { startScroll, stopScroll } from "@/lib/lenis";

export const SizeGuide = ({ product }) => {
  const guide = SIZE_GUIDES[product.size_guide];
  if (!guide) return null;

  return (
    <Dialog onOpenChange={(open) => (open ? stopScroll() : startScroll())}>
      <DialogTrigger asChild>
        <button data-testid={`size-guide-button-${product.id}`} className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-cream/70 underline-offset-4 transition-colors hover:text-cream hover:underline">
          <Ruler className="h-3.5 w-3.5" /> Guida taglie
        </button>
      </DialogTrigger>
      <DialogContent data-testid="size-guide-dialog" data-lenis-prevent className="max-w-lg gap-0 rounded-none border-line bg-[#0c0c0c] p-0 text-bone sm:rounded-none">
        <div className="border-b border-line p-6 pr-12">
          <DialogTitle className="font-display text-xl font-black uppercase tracking-tight text-cream">Guida taglie</DialogTitle>
          <DialogDescription className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke">
            {product.name} · {guide.fit}
          </DialogDescription>
        </div>
        <div className="overflow-x-auto p-6">
          <table className="w-full min-w-[360px] text-sm" data-testid="size-guide-table">
            <thead>
              <tr>
                {guide.columns.map((c) => (
                  <th key={c} className="border-b border-line pb-3 text-left font-mono text-[10px] font-normal uppercase tracking-[0.18em] text-smoke">{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {guide.rows.map((row) => (
                <tr key={row[0]} className="border-b border-line last:border-b-0" data-testid={`size-guide-row-${row[0].toLowerCase()}`}>
                  {row.map((v, i) => (
                    <td key={guide.columns[i]} className={`py-3 ${i === 0 ? "font-display font-bold text-cream" : "font-mono text-bone/80"}`}>{v}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <p className="mt-5 text-xs leading-relaxed text-bone/60">{guide.note}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
